import { Component, OnInit, Input, ElementRef, Renderer2 } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SelectionInfoComponent } from '../../../../modals/selection-info/selection-info.component';
import { meetingData_pObj } from '../../../../services/payload/meetingData_pobj'
import { BettingServiceService } from '../../../../services/betting_service/betting-service.service';
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { AlertController } from '@ionic/angular';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { EventInfoComponent } from '../../../../modals/event-info/event-info.component';
import { meetingMeta_pObj, meetingMeta_greyHound_pObj } from '../../../../services/payload/meetingMeta_pobj';
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-next-ten-odds',
  templateUrl: './next-ten-odds.component.html',
  styleUrls: ['./next-ten-odds.component.scss'],
})
export class NextTenOddsComponent implements OnInit {

  @Input()
  selectedBetCategory: any;
  ODDs: any = [];
  viewSelectionBlock: boolean;
  selectedMeeting: any;
  oddId: any;
  metaEventLable: any;
  metaEventName: any;
  metaEventLocalDate: any;
  metaeventTime: any;
  metaeventSelectedBetCategory: any;
  is_logged: boolean = false;
  is_AU = false;
  info_button_show: boolean = true;
  betcatselection: any;
  scrollId: string;

  constructor(
    public modalController: ModalController,
    private bettingService: BettingServiceService,
    private commanService: CommonServiceService,
    public alertController: AlertController,public ele: ElementRef,
    private stmgService: StmgService,public renderer: Renderer2
  ) {

  }

  ngOnInit() {
    this.viewSelectionBlock = false;
    this.stmgService.cast_clickStatus.subscribe(clicked => {
      this.viewSelectionBlock = clicked;
      if(!clicked){
        let el = document.getElementById(this.scrollId);
        setTimeout(() => {
          if(el){el.scrollIntoView();}
        }, 100);
      }
    });
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );
    this.is_no_data = false;

    this.stmgService.nav2next10Refresh_status.subscribe(clicked => {
      if (clicked == 'yes') {
        this.ngOnChanges();
      }
    });

  }


  viewInfoDetails(event) {
    this.bettingService.getEventMetaData(event.id).subscribe(result => {
      this.PopUpEventInfoModel(event, result)
    },
      error => {
        //console.log("EE:", error);
      });
  }


  async PopUpEventInfoModel(event, metaData) {
    const modal = await this.modalController.create({
      component: EventInfoComponent,
      componentProps: {
        metaData: metaData,
        event: event
      },
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  viewRaceDetails(d: any,event,i) {
    this.scrollId="scrollto"+i

    let myTag = this.ele.nativeElement.querySelectorAll(".betting-category");
      myTag.forEach(ele => {
        ele.classList.remove('selected');
      })

    let element=event.target;
    for (let index = 0; index < 10; index++) {
      if (element.id == "dropdown"){
        this.renderer.addClass(element, 'selected');
        break;
      }else{
        element=element.parentNode;
      }
    }
    this.betcatselection = this.selectedBetCategory.name;
    this.viewSelectionBlock = true;
    this.selectedMeeting = d;
  }

  ngOnChanges() {
    this.is_AU = false;
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.ODDs = [];
    this.viewSelectionBlock = false;
    this.getMeetingData(this.selectedBetCategory);

    this.is_no_data = false;
  }

  // Get Meeting Data
  getMeetingData(data: any) {
    let meetingPayload = new meetingData_pObj();
    meetingPayload.country = data.country;
    meetingPayload.date = this.commanService.getCurrentDateTime();
    meetingPayload.filter = data.filter;
    meetingPayload.inplay = data.inplay;
    meetingPayload.sport = data.sport;

    if (data.country == 'AU') {
      this.is_AU = true;
    }

    this.bettingService.getMeetingData(meetingPayload).subscribe(data => {
      this.validatePayload(data);
    }, (error) => {

    });
  }

  getMeetingMetaData(oddID: any) {
    this.bettingService.getEventMetaData(oddID).subscribe(
      result => {
        if (result) {
          this.validatePayload_MeetingMetaData(result)
        }
        else {
          //console.log("data not found");
        }
      },
      error => {
        //console.log("EE:", error);
      });
  }

  validatePayload_MeetingMetaData(data: any) {

    if (this.selectedBetCategory.name != "UK Greyhounds") {
      if (Object.entries(data).length === 0) {
        var meta_data = new meetingMeta_pObj();
        meta_data.selectedBetCategory = this.selectedBetCategory.name;
        meta_data.eventLable = this.metaEventLable;
        meta_data.eventName = this.metaEventName;
        meta_data.eventLocalDate = this.metaEventLocalDate;
        meta_data.eventTime = this.metaeventTime;
        
      }
      else {
        var meta_data = new meetingMeta_pObj();
        meta_data.selectedBetCategory = this.selectedBetCategory.name;
        meta_data.eventLable = this.metaEventLable;
        meta_data.eventName = this.metaEventName;
        meta_data.eventLocalDate = this.metaEventLocalDate;
        meta_data.eventTime = this.metaeventTime;
        meta_data.track_type = data.eventMetaData.trackType;
        meta_data.going = data.eventMetaData.going;
        meta_data.trifecta = data.eventMetaData.trifecta;
        meta_data.raceType = data.eventMetaData.raceType;
        meta_data.handicap = data.eventMetaData.handicap;
        meta_data.maxrunners = data.eventMetaData.maxrunners;
        meta_data.amount = data.eventMetaData.addedMoneyAmount;
        meta_data.eligibilty_type = data.eventMetaData.eligibilty_type;
        meta_data.distance = data.eventMetaData.distance;
        meta_data.lastWinnerHorsePrice = data.eventMetaData.lastWinnerHorsePrice;
        meta_data.lastWinnerYear = data.eventMetaData.lastWinnerYear;
        meta_data.lastWinnerHorse = data.eventMetaData.lastWinnerHorse;
        meta_data.lastWinnerHorseWeightText = data.eventMetaData.lastWinnerHorseWeightText;
        meta_data.lastWinnerRan = data.eventMetaData.lastWinnerRan;
        meta_data.lastWinnerHorseTrainerName = data.eventMetaData.lastWinnerHorseTrainerName;
        meta_data.lastWinnerHorseJockeyName = data.eventMetaData.lastWinnerHorseJockeyName;
        meta_data.lastWinnerHorseAgeYears = data.eventMetaData.lastWinnerHorseAgeYears;
        //this.PopUpEventInfoModel(meta_data);
      }
    }
    else if (this.selectedBetCategory.name == "UK Greyhounds") {

      if (Object.entries(data).length === 0) {
        var meta_data_greyhound = new meetingMeta_greyHound_pObj();

        meta_data_greyhound.selectedBetCategory = this.selectedBetCategory.name;
        meta_data_greyhound.eventLable = this.metaEventLable;
        meta_data_greyhound.eventName = this.metaEventName;
        meta_data_greyhound.eventLocalDate = this.metaEventLocalDate;
        meta_data_greyhound.eventTime = this.metaeventTime;
      }
      else {
        var meta_data_greyhound = new meetingMeta_greyHound_pObj()
        meta_data_greyhound.selectedBetCategory = this.selectedBetCategory.name;
        meta_data_greyhound.eventLable = this.metaEventLable;
        meta_data_greyhound.eventName = this.metaEventName;
        meta_data_greyhound.eventLocalDate = this.metaEventLocalDate;
        meta_data_greyhound.eventTime = this.metaeventTime;
        meta_data_greyhound.greyhound_type = data.eventMetaData.type;
        meta_data_greyhound.greyhound_class = data.eventMetaData.class;
        meta_data_greyhound.greyhound_handicap = data.eventMetaData.handicap;
        meta_data_greyhound.greyhound_distance = data.eventMetaData.distance;
      }
    }
  }
  meetingOdds(data: any) {
    let tempData = data.payload[0].eventLightDTOs;
    for (let i = 0; i < tempData.length; i++) {
      this.ODDs[i] = {
        cat: tempData[i].cat,
        eventCode: tempData[i].eventCode,
        eventLabel: tempData[i].eventLabel,
        eventLocalDate: tempData[i].eventLocalDate,
        eventName: tempData[i].eventName,
        eventTime: this.commanService.trimEventTime(tempData[i].eventTime),
        id: tempData[i].id,
        meetingCat: tempData[i].meetingCat,
        meetingName: tempData[i].meetingName,
      }
    }
  }

  is_no_data = false;
  validatePayload(data: any) {
    if (data.status !== 'success' || !data.payload.length) {
      this.is_no_data = true;
    } else {
      this.meetingOdds(data)
      this.updateMeetingDataSTMG(data);
    }
  }

  updateMeetingDataSTMG(d: any) {
    this.stmgService.updateMeetingData(d);
  }

  

}
